module.exports = __webpack_public_path__ + "static/media/Car.77f1602d.svg";